export class ScheduleFetcher {
    constructor(scheduleId, urls) {
        this.scheduleId = scheduleId;
        this.urls = urls;
    }
    async fetch() {
        const response = await fetch(`${this.urls.api}tego-jitsi/schedule/${this.scheduleId}`, {
            credentials: "include"
        });
        if (!response.ok)
            throw new Error("Error fetching schedule");
        return response.json();
    }
}
